export default "__VITE_ASSET__B53bt72Z__"